import React, { lazy, Suspense, useEffect, useState } from "react"

import { ReactSVG } from 'react-svg'
import { MdCancel } from '@react-icons/all-files/md/MdCancel'


// Helper function to assign icon based on name
const assignIcon = (name, icon) => {
  const iconMap = {
    "Concert": 'music',
    "Music": 'music',
    "Arts & Entertainment": 'art',
    "Comedy": 'comedy',
    "Festival": 'festival',
    "Book": 'book',
    "Attractions": 'attractions',
    "Film": 'film',
    "Food": 'food',
    "Services": 'community',
    "Sports & Fitness": 'sports',
    "Wellness": 'health',
  };

  const bestIcon = iconMap[name] || icon
  return bestIcon;
}

const PillButton = ({
  name,
  count = null,
  key = null,
  link = undefined,
  slug = 'all',
  type = 'activity',
  onCancelCallback = null,
  onClickCallback = null,
  selected = null,
  isActive = false,
  isSelected = false,
  showIcon = true,
  showRemove = false,
  icon = null,
  ...props
}) => {


  const handleClick = (e, slug) => {
    if (onClickCallback) onClickCallback(e, slug, isActive)
  }

  const handleCancel = (e) => {
    if (onCancelCallback) onCancelCallback(e, slug, isActive)
  }

  // Use prop or assign icon based on name
  icon = showIcon && assignIcon(name, icon);
  const level = selected?.level
  var hasIcon = showIcon && icon !== null || level <= 2

  const svg_size = level == 1 ? '1.6rem' : '1.2rem'
  const svg_class = `icon ${icon}`
  const svg_path = `/assets/icons/${icon}.svg`

  const svg = (
    <ReactSVG
      className={svg_class}
      src={svg_path}
    />
  )

  const remove = (
    <MdCancel
      className={'remove'}
      size='1.6rem'
      onClick={(e) => handleCancel} />
  )

  return (
    <a
      className={`pill ${type} ${isSelected ? 'selected' : ''}`}
      draggable='false'
      key={slug}
      href={link}
      onClick={(e => handleClick(e, slug))}>
      {hasIcon ? svg : null}
      <span>{name}</span>
      {showRemove ? remove : null}
      {count ? <span className='count'>{count}</span> : null}
    </a>
  )
}

export default PillButton